export default __webpack_public_path__ + "static/media/inbound.7b07f2aa.svg";